import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const emailTemplateDefaultsApi = createApi({
  reducerPath: 'emailTemplateDefaultsApi',
  baseQuery: createBaseQuery('email_template_defaults'),
  tagTypes: ['EmailTemplateDefault'],
  endpoints: builder => ({
    getEmailTemplateDefaults: builder.query({
      query: params => `?${toQueryParams(params || {})}`,
      transformResponse: ({ result }) => result,
      providesTags: ['EmailTemplateDefault'],
    }),
    createEmailTemplateDefault: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['EmailTemplateDefault'],
    }),
    updateEmailTemplateDefault: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['EmailTemplateDefault'],
    }),
    deleteEmailTemplateDefault: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailTemplateDefault'],
    }),
  }),
});

export const {
  useGetEmailTemplateDefaultsQuery,
  useCreateEmailTemplateDefaultMutation,
  useUpdateEmailTemplateDefaultMutation,
  useDeleteEmailTemplateDefaultMutation,
} = emailTemplateDefaultsApi;
